<template>
    <Dialog
        v-if="((!entity?.properties?.options || entity?.properties?.options === 'YES') && base.Util().validate(entity?.metas)) || entity?.properties?.DOWNLOAD === 'YES' || entity?.properties?.DOCUMENT === 'YES'"
        :data="dialog[dialog.active]" :show="dialog['show']" @onclose="() => dialog['show'] = false"
        @onloading="onloading" @onresult="onresult">
    </Dialog>
    <div v-if="base.Util().validate(entity?.metas)" class="head">
        <div v-if="(headtitle || entity?.title || entity_data?.title) && (!entity.properties?.notitle || entity.properties?.notitle === 'NO')"
            class="title">
            <h1>{{ headtitle || entity_data?.title || entity?.title }}</h1>
        </div>
        <div v-if="!entity.properties?.filter || entity.properties?.filter === 'YES'" class="filter">
            <template v-for="(meta, index) in metas.filter((meta) => { return meta.type === 'tab' })" :key="index">
                <div class="full tab flex wrap center vcenter">
                    <Tabs :meta="meta" :vm="models[meta.key] || this.base.Entities().parse(meta.extras)['default']"
                        @onchange="filter">
                    </Tabs>
                </div>
            </template>
        </div>
        <div v-if="(!entity.properties?.options || entity.properties?.options === 'YES') && (!entity.properties?.OPTIONS || entity.properties?.OPTIONS === 'YES')"
            class="options flex">
            <div class="right flex start vcenter">
                <Option v-if="!entity.properties?.search || entity.properties?.search === 'YES'" :color="'blue'"
                    :icon="'fe-search'" :name="'جست و جو'" @onclick="() => {
                        if (dialog['active'] === 'search')
                            dialog['show'] = !dialog['show']
                        else {
                            dialog['active'] = 'search'
                            dialog['show'] = true
                        }
                    }">
                </Option>
                <Option
                    v-if="this.visibilities['simplify'] && (!entity.properties?.simplify || entity.properties?.simplify === 'YES')"
                    :color="simplify ? 'crimson' : 'green'" :icon="simplify ? 'fe-file-text' : 'fe-feather'"
                    :name="simplify ? 'بارگذاری کامل' : 'بهینه سازی'" @onclick="simplify = !simplify">
                </Option>
            </div>
            <div class="left flex end vcenter">
                <Option v-if="this.visibilities['add'] && (!entity.properties?.add || entity.properties?.add === 'YES')"
                    :color="'green'" :icon="'fe-plus'" :name="'افزودن'"
                    @onclick="entity.properties?.ADDHREF ? this.$router.push(entity.properties?.ADDHREF) : open(entity.properties?.ADDTYPE)">
                </Option>
                <Option
                    v-if="this.visibilities['remove'] && (!entity.properties?.remove || entity.properties?.remove === 'YES')"
                    :color="'crimson'" :icon="'fe-x'" :name="'حذف'"></Option>
                <Option
                    v-if="this.visibilities['export'] && (!entity.properties?.export || entity.properties?.export === 'YES')"
                    :color="'cadetblue'" :icon="'fe-download'" :name="'برون بری'" @onclick="() => {
                        if (dialog['active'] === 'export')
                            dialog['show'] = !dialog['show']
                        else {
                            dialog['active'] = 'export'
                            dialog['show'] = true
                        }
                    }">
                </Option>
            </div>
        </div>
    </div>
    <div v-if="base.Util().validate(entity?.metas)" class="table">
        <div class="contents">
            <THead :entity_type="entity_type" :page="page" :size="size" :data="this.data()" :update="update"
                @onorder="onorder" @onchange="onchange">
            </THead>
            <TBody :entity_type="entity_type" :page="page" :size="size" :data="this.data()" :contents="contents"
                :update="update" :user="user" @onchange="onchange" @onloading="onloading" @ondownload="(obj) => {
                    dialog['document']['entity'] = obj
                    dialog['active'] = 'document'
                    dialog['show'] = true
                }" @ondocument="(obj) => {
                    dialog['request']['entity'] = obj
                    dialog['request']['entity']['grade'] = user?.grade
                    dialog['active'] = 'request'
                    dialog['show'] = true
                }">
            </TBody>
        </div>
        <TFooter :entity_type="entity_type" :page="page" :size="size" :count="count" :update="update"></TFooter>
    </div>
</template>

<script>
/* eslint-disable */
import Option from './Form/Option.vue'
import Dialog from './Dialog.vue'
import Tabs from './Form/Inputs/Tabs.vue'
import Switch from './Form/Inputs/Switch.vue'

import THead from './Table/THead.vue'
import TBody from './Table/TBody.vue'
import TFooter from './Table/TFooter.vue'

export default {
    name: 'List',
    props: ['entity_type', 'page', 'size', 'entity_data', 'contents', 'update', 'user'],
    inject: ['base'],
    components: { Option, Dialog, Tabs, Switch, THead, TBody, TFooter },
    computed: {
        headtitle() {
            return this.$route.meta?.headtitle
        },
        query() {
            return this.entity_data?.properties?.query
        }
    },
    created() {
        this.init()
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.adjustTableColumnWidths)
        if (this.observer) {
            this.observer.disconnect()
        }
    },
    data() {
        return {
            entity: {},
            metas: [],
            columns: [],
            accesses: {},
            visibilities: {},
            models: {},
            order: '[created_at]',
            direction: 'DESC',
            simplify: true,
            count: 0,
            selected: [],
            all: false,
            dialog: {},
        }
    },
    watch: {
        entity_type(newEntity, oldEntity) {
            this.init()
        },
        update(newUpdate, oldUpdate) {
            this.init()
        },
        query: {
            handler(newQuery, oldQuery) {
                if (newQuery)
                    Object.keys(newQuery).forEach((key) => {
                        if (oldQuery && oldQuery[key] !== newQuery[key]) {
                            this.init()
                            return
                        }
                    })
            },
            deep: true
        },
        models: {
            handler(newModels, oldModels) {
                if (!this.entity.properties?.filter || this.entity.properties?.filter === 'YES') {
                    const query = {}
                    for (const key of Object.keys(this.$route.query))
                        query[key] = this.$route.query[key]
                    for (const key of Object.keys(this.models))
                        query[key] = this.models[key]

                    this.$router.push({ path: window.location.pathname, query: query })
                    this.visibility()
                }
            },
            deep: true
        }
    },
    methods: {
        data() {
            return {
                entity: this.entity,
                metas: this.metas?.filter((meta) => { return meta.type !== 'tab' }),
                columns: this.columns,
                visibilities: this.visibilities,
                models: this.models,
                order: this.order,
                direction: this.direction,
                simplify: this.simplify,
                count: this.count,
                selected: this.selected,
                all: this.all,
                observer: null
            }
        },
        init() {
            this.entity = {}
            if (this.entity_type) {
                if (!this.entity_data?.properties?.SUBLIST)
                    this.$emit('onloading', true)
                this.base.API().post(`Data/Entity/Find`, {
                    entity_type: this.entity_type.toUpperCase(),
                    options: 'LIST'
                }, (response) => {
                    if (this.base.Util().success(response) && response.data.data) {
                        this.entity = response.data.data || { properties: {}, options: {}, metas: [] }
                        if (this.entity_data) {
                            this.entity.title = this.entity_data.title
                            Object.assign(this.entity.properties || {}, this.entity_data.properties)
                            Object.assign(this.entity.options || {}, this.entity_data.options)
                        }

                        this.dynamic = ['ACCOUNT', 'GROUP', 'ROLE', 'FOLDER', 'FILE', 'POST', 'CATEGORIZE', 'TAG']
                            .includes(this.entity_type.toUpperCase())

                        this.metas = this.entity?.metas?.filter((meta) => {
                            return meta.entity_type === this.entity_type.toUpperCase()
                                && !['avatar', 'files', 'file', 'step'
                                    , 'password', 'multiparams', 'span', 'space'
                                    , 'button'].includes(meta.type)
                                && meta.listable
                        }).sort((e1, e2) => (Number(this.base.Entities().parse(e1.extras)['order'] || e1.order) > Number(this.base.Entities().parse(e2.extras)['order'] || e2.order))
                            ? 1 : (Number(this.base.Entities().parse(e1.extras)['order'] || e1.order) < Number(this.base.Entities().parse(e2.extras)['order'] || e2.order)) ? -1 : 0)

                        this.dialog = {
                            search: {
                                type: 'search',
                                title: 'جست و جو',
                                entity_type: this.entity_type,
                                metas: this.metas,
                                internal: true,
                                closeable: true
                            },
                            export: {
                                type: 'export',
                                title: 'برون بری',
                                thin: true,
                                entity_type: this.entity_type,
                                search: this.entity?.properties?.SEARCH,
                                query: this.query,
                                internal: true,
                                closeable: true
                            },
                            document: {
                                type: 'document',
                                title: 'دریافت نسخه الکترونیکی گواهی شراکت',
                                thin: true,
                                internal: true,
                                closeable: true
                            },
                            request: {
                                type: 'request',
                                title: 'ثبت درخواست بر روی پرونده',
                                thin: true,
                                internal: true,
                                closeable: true
                            },
                            active: 'search',
                            show: false
                        }

                        this.dialog[this.entity_type] = {
                            type: 'form',
                            thin: true,
                            entity_type: this.entity_type,
                            internal: true,
                            closeable: true,
                            data: {
                                title: this.entity.title,
                                properties: {
                                    RELOAD: 'NO'
                                }
                            }
                        }

                        this.metas?.forEach((meta) => {
                            if (meta.type === 'tab' && meta.extras && meta.extras.includes('key=default')
                                && !this.base.Util().validate(this.models[meta.key]))
                                this.models[meta.key] = this.base.Entities().parse(meta.extras)['default']
                        })

                        this.entity?.accesses?.filter((access) => {
                            return access.data.toUpperCase().startsWith(`${this.entity_type.toUpperCase()}_LIST`)
                                || access.data === 'PERSIST'
                        }).forEach((element) => {
                            this.accesses[element.data.replaceAll(`${this.entity_type.toUpperCase()}_LIST(`, '')
                                .replaceAll(')', '').toLowerCase()] = element.action.toLowerCase()
                        })

                        let options = ['ADD', 'REMOVE', 'VIEW', 'DELETE', 'DOWNLOAD', 'DOCUMENT', 'SIMPLIFY', 'USER', 'MAXIMIZE', 'EXPORT']
                        options.forEach(key => {
                            let access = (this.accesses[key.toLowerCase()] || this.accesses['persist'])
                            if (key === 'DOWNLOAD' || key === 'DOCUMENT')
                                this.visibilities[key.toLowerCase()] = this.entity?.properties?.[key] === 'YES' || false

                            if (this.visibilities[key.toLowerCase()] !== false)
                                this.visibilities[key.toLowerCase()] = (!this.entity?.properties[key] || this.entity?.properties[key] === 'YES')
                                    && access && (access === 'visible' || access === 'accept')
                        })

                        this.visibilities['operations'] = this.visibilities['view'] || this.visibilities['delete'] || this.visibilities['download'] || this.visibilities['document'] || this.visibilities['user'] || this.visibilities['maximize']
                        this.visibilities['shield'] = this.entity?.properties['SHIELD'] === 'YES'
                        this.visibilities['created_at'] = this.entity?.properties['CREATED_AT'] === 'YES'
                        this.visibilities['status'] = this.entity?.properties['STATUS'] === 'YES'

                        this.visibility()

                        setTimeout(() => {
                            const container = document.querySelector('.table')
                            if (container && window.ResizeObserver) {
                                this.observer = new ResizeObserver(() => {
                                    this.adjustTableColumnWidths()
                                })
                                this.observer.observe(container)
                            }
                        }, 1000)
                        window.addEventListener('resize', this.adjustTableColumnWidths)
                    } else
                        this.$emit('onloading', false)

                }, (error) => {
                    this.$emit('onloading', false)

                })
            }
        },
        adjustTableColumnWidths() {
            const containerWidth = document.querySelector('.table')?.clientWidth || window.innerWidth
            let total = 0
            let pxColumns = {}

            this.metas?.forEach(meta => {
                if (meta.extras && (this.visibilities[meta.key] === 'visible' || this.visibilities[meta.key] === true)) {
                    let width = this.base.Entities().parse(meta.extras)['column']
                    if (width && String(width).includes('px')) {
                        const w = parseInt(String(width).replace('px', ''))
                        total += w
                        pxColumns[meta.key] = w
                    }
                }
            })

            let constant = 142
            if (this.entity?.['properties']?.CREATED_AT === 'YES')
                constant += 154
            if (this.entity?.['properties']?.STATUS === 'YES')
                constant += 154
            if (this.entity?.['properties']?.PROCESS)
                constant += 169

            const remaining = containerWidth - total - constant

            let extra = 0
            if (remaining > 0 && Object.keys(pxColumns).length > 0)
                extra = Math.floor(remaining / Object.keys(pxColumns).length)
            for (const key of Object.keys(pxColumns))
                pxColumns[key] = `${pxColumns[key] + extra}px`

            this.columns = pxColumns
        },
        onorder(obj) {
            this.order = obj.order
            this.direction = obj.direction
        },
        onchange(obj) {
            this.count = obj.count
            this.selected = obj.selected
            this.all = obj.all
        },
        filter(obj) {
            this.models[obj.key] = obj.value
            const query = {}
            for (const key of Object.keys(this.$route.query))
                query[key] = this.$route.query[key]
            for (const key of Object.keys(this.models))
                query[key] = this.models[key]
            this.$router.push({ path: window.location.pathname, query: query })
            this.visibility()
        },
        visibility() {
            this.metas?.forEach((meta) => {
                let access = (this.accesses[meta.key] || this.accesses['persist'])
                let authentic = access && ['visible', 'hidden', 'gone'].includes(access)
                if (String(this.entity[this.component]?.properties?.excludes || '')?.includes(meta.key))
                    this.visibilities[meta.key] = 'gone'
                else {
                    if (meta.extras && meta.extras.includes('key=v-key')) {
                        let extras = this.base.Entities().parse(meta.extras)
                        if (extras) {
                            let key = extras['v-key']
                            if (typeof (key) === 'string')
                                this.visibilities[meta.key] = String(this.models[key]) === String(extras[key]) || !this.metas?.find(meta => meta.key === key)
                                    ? authentic ? access : 'visible' : 'gone'
                            else if (Array.isArray(key)) {
                                let visibility = authentic ? access : 'visible'
                                for (const element in key)
                                    if (String(this.models[key[element]]) !== String(extras[key[element]]) && this.metas?.find(meta => meta.key === element)) {
                                        visibility = 'gone'
                                        break
                                    }
                                this.visibilities[meta.key] = visibility
                            }
                        }
                    } else if (authentic)
                        this.visibilities[meta.key] = access
                    else
                        this.visibilities[meta.key] = 'visible'
                }
            })
            setTimeout(() => {
                this.adjustTableColumnWidths()
            }, 500)
        },
        open(type) {
            if (type && type === 'popup') {
                this.dialog['active'] = this.entity_type
                this.dialog['show'] = true
            }
            else
                window.open(`/Dashboard/Form/${this.entity_type}`)
        },
        onloading(status) {
            this.$emit('onloading', status)
        },
        onresult(obj) {
            if (this.dialog['active'] === this.entity_type) {
                if (this.base.Util().success({ data: obj })) {
                    if (this.entity?.properties?.POSTACTION === 'buffer') {
                        this.onloading(true)
                        this.base.Entities().receive(obj.data)
                        this.onloading(false)
                    }
                    this.dialog['show'] = false

                    setTimeout(() => {
                        location.reload()
                    }, 3000);
                }
            } else
                this.dialog['show'] = false
        }
    }
}
</script>

<style src="../assets/css/components/list.css"></style>
<style src="../assets/css/components/list_dark.css"></style>
